import { MandateType } from '@wize-mobile-api';
import { PortfolioMandateType } from '@qvs/core';

export class MandateTypeMapper {
  public static fromWizeMandateType = (mandateType: MandateType): PortfolioMandateType | undefined =>
    !mandateType ? undefined : { ...mandateType };

  public static fromWizeMandateTypes = (mandateTypes: MandateType[]): PortfolioMandateType[] =>
    mandateTypes.map((mandateType) => MandateTypeMapper.fromWizeMandateType(mandateType));
}
